import { TypographyComponent as Typography, TypographyComponentProps } from "@tvg/fuse-design/typography-element";
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

export interface HeadingProps extends TypographyComponentProps<"h1", "heading"> {}

const StyledTypography = styled(Typography)`
  & {
    padding-top: var(--spacing-space16);
    padding-bottom: var(--spacing-space16);
  }
`;

const Heading = (props: PropsWithChildren<HeadingProps>) => {
  return (
    <StyledTypography
      dataTestId="results-heading"
      tag="h1"
      size={{
        xxs: "3",
        m: "4",
        l: "6",
      }}
      {...props}
    />
  );
};

export default React.memo(Heading);
